export default (value: any) => {
  if (value === null || value === undefined || value === '') {
    return true;
  }
  return RegExp('^(0\\d{9}|\\+66\\d{9})$').test(value);
};
